import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotifiactionService {
  snackBarEvent$  : EventEmitter<string>;

  showNewSnackBar(message : string) {
    this.snackBarEvent$.emit(message);
  }

  constructor() {
    this.snackBarEvent$ = new EventEmitter<string>();
  }
}
